/** Fixed simulation step (60 Hz). */
export const SIM_DT = 1 / 60
/** Longest frame time carried into the sim; prevents a catch-up spiral after a stall. */
export const MAX_FRAME_SECONDS = 0.25
const EPSILON = 1e-9

export interface Stepper {
  accumulator: number
}

export function createStepper(): Stepper {
  return { accumulator: 0 }
}

/** Adds real frame time (clamped) and returns how many fixed ticks to run now. */
export function consumeTicks(stepper: Stepper, frameSeconds: number): number {
  stepper.accumulator += Math.min(Math.max(frameSeconds, 0), MAX_FRAME_SECONDS)
  let ticks = 0
  while (stepper.accumulator >= SIM_DT - EPSILON) {
    stepper.accumulator -= SIM_DT
    ticks++
  }
  return ticks
}

/** Blend factor in [0, 1] between the previous and current sim state. */
export function interpolationAlpha(stepper: Stepper): number {
  return Math.min(Math.max(stepper.accumulator / SIM_DT, 0), 1)
}

export function resetStepper(stepper: Stepper): void {
  stepper.accumulator = 0
}
